/**
 * Welke hoofdbestemmingen er bestaan voor déze medewerker bij dít bedrijf (Extra 6, punt 1).
 *
 * Een losse functie en geen `if` per tab: zodra dat per tab gebeurt, staat de ene voorwaarde in de
 * onderbalk en de andere in de zijbalk, en verschijnt een tab op een telefoon die op een
 * bureauscherm verdwijnt. Dit is de enige plek waar de regel staat; de onderbalk en de zijbalk
 * stellen allebei dezelfde twee vragen.
 */

export interface GatedItem {
  /** Het recht dat de bestemming bewaakt. Ontbreekt het, dan is de bestemming er voor iedereen. */
  policy?: string;
  /** De tenantvlag die de functie aan- of uitzet. */
  flag?: string;
}

export interface VisibilityChecks {
  /**
   * Heeft deze medewerker dit recht?
   *
   * Dit beantwoordt ook de vraag "draait die module wel": een module die uit staat, registreert
   * zijn rechten niet, dus niemand heeft ze - ook een beheerder niet.
   */
  has: (policyKey: string) => boolean;
  /** Staat deze vlag aan bij dit bedrijf? Bij twijfel `true`; zie `useTenantFeatures`. */
  isOn: (flagKey: string) => boolean;
}

/** Houdt de bestemmingen over waar deze medewerker werkelijk iets vindt. */
export function visibleItems<T extends GatedItem>(items: T[], checks: VisibilityChecks): T[] {
  return items.filter(
    (item) =>
      (item.policy ? checks.has(item.policy) : true) && (item.flag ? checks.isOn(item.flag) : true),
  );
}
